import React from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { createAbsoluteUrl } from 'utils/constants';
import { AlwaysConnected } from './always-connected';

const hideAlwaysConnectedPaths = [
  "/my-account/dashboard",
  "/my-account/payment-history",
  "/my-account/manage-profile",
  "/my-account/change-password",
  "/my-account/sim-service",
];

const topFooterLinks = [
  {
    width: '10.375rem',
    name: 'Mobile Service',
    links: [
      { label: 'Single Network', to: '/network-coverage#coverage-map' },
      { label: 'Multi Network', to: '/network-coverage#triple-network-technology' },
      { label: 'Family Plans', to: '/family-plans' },
      { label: 'Coverage Map', to: '/network-coverage#coverage-map' },
    ]
  },
  {
    width: '11.875rem',
    name: 'Our Network',
    links: [
      { label: 'International Roaming', to: '/international-calling#international-roaming' },
      { label: 'ILD Calls and SMS', to: '/international-calling' },
      { label: 'Triple 5G Network', to: '/how-vle-mobile-works#triple-5g-network' },
      { label: 'Double SIM Technology', to: '/how-vle-mobile-works#double-sim-technology' },
    ]
  },
  {
    width: '10rem',
    name: 'Exclusive Features',
    links: [
      { label: 'Aura Security Plans', to: '/digital-security' },
      { label: 'SIM Swap Protection', to: '/sim-swap-protection' },
      { label: 'Built-in VPN', to: 'https://vlemobile.tawk.help/article/vle-mobile-built-in-vpn', target: '_blank' },
      { label: 'Mobile APP', to: '#' },
    ]
  },
  {
    width: '7.6875rem',
    name: 'Useful Links',
    links: [
      { label: 'Platform Drivers', to: '/platform-drivers' },
      { label: 'How it Works', to: '/how-vle-mobile-works' },
      { label: 'How to Switch', to: '/how-to-switch' },
      { label: 'What is eSIM', to: '/about-esim' },
    ]
  },
  {
    width: '8rem',
    name: 'Support',
    links: [
      // { label: 'Support Tickets', to: '/support-tickets' },
      { label: 'Support Tickets', to: createAbsoluteUrl('/support-tickets'), target: '_self' },
      { label: 'Knowledge Base', to: 'https://vlemobile.tawk.help', target: '_blank' },
      // { label: 'Contact Us', to: '/support-center' },
      { label: 'Contact Us', to: createAbsoluteUrl('/support-center'), target: '_self' },
      // { label: 'Blog', to: '/resource-center' },
      { label: 'Blog', to: createAbsoluteUrl('/resource-center'), target: '_self' },
    ]
  },
  {
    width: '11.25rem',
    name: 'Legal',
    links: [
      { label: '911 & e911 Disclosure', to: '/e911/911-emergency-services-statement' },
      { label: 'Network Management', to: '/network-management-policy' },
      { label: 'Accessiblity', to: '/accessibility' },
      { label: 'Return Policy', to: '/return-policy' },
    ]
  }
];

const bottomFooterLinks = [
  { label: 'Company Information', to: '/about-us' },
  // { label: 'FAQ', to: '/faq' },
  { label: 'FAQ', to: createAbsoluteUrl('/faq'), target: '_self' },
  { label: 'Terms & Conditions', to: '/terms-and-conditions' },
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: 'Cookie Policy', to: '/privacy-policy#cookie-policy' },
  { label: 'Deletion Policy', to: '/deletion-suspension-policy' },
  { label: 'Do not Sell My Data', to: '/do-not-sell' },
  { label: 'Your Privacy Choices', to: '/do-not-sell#privacy-choices' }
];

const socialLinks = [
  { icon: '/assets/facebook-logo.svg', alt: 'Facebook', to: 'https://www.facebook.com/vlemobile' },
  { icon: '/assets/twitter-logo.svg', alt: 'Twitter', to: 'https://www.x.com/vle_mobile' },
  { icon: '/assets/instagram-logo.svg', alt: 'Instagram', to: 'https://www.instagram.com/vlemobile/' },
  { icon: '/assets/youtube-logo.svg', alt: 'YouTube', to: 'https://www.youtube.com/@VLEMobile' },
  { icon: '/assets/linkedin-logo.svg', alt: 'LinkedIn', to: 'https://www.linkedin.com/in/vlemobile/' }
];

export const Footer = () => {
  const location = useLocation();

  return (
    <React.Fragment>
      {!hideAlwaysConnectedPaths.includes(location.pathname) && <AlwaysConnected />}
      <footer className="w-full bg-[#111111] pt-7 sm:pt-9 md:pt-11 lg:pt-[3.5625rem] pb-6 sm:pb-8 md:pb-10 lg:pb-12 px-4 sm:px-6 md:px-7 lg:px-8">
        <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-6 xl:gap-x-10 2xl:gap-x-20 gap-y-5 sm:gap-y-6 lg:gap-y-7 justify-between w-full max-w-[94.25rem] px-1 sm:px-1.5 lg:px-2 pb-4 sm:pb-5 md:pb-6 lg:pb-8 border-b border-[#8888884D] mx-auto">
          {topFooterLinks.map((link, index) => (
            <nav
              key={link.name}
              className={`flex ${index % 2 === 0 ? '' : 'justify-end'} ${index === 1 || index === 4 ? 'sm:justify-center' : index === 2 || index === 5 ? 'sm:justify-end' : 'sm:justify-start'} xl:justify-start 2xl:w-[${link.width}]`}
            >
              <div className="min-w-[9.25rem] sm:min-w-44">
                <h3 className="text-[#D9D9D9] text-[0.825rem] sm:text-sm md:text-[0.925rem] lg:text-base font-extrabold leading-4 sm:leading-5 lg:leading-6 mb-1.5 sm:mb-2 lg:mb-[0.66rem]">
                  {link.name}
                </h3>
                <ul className="flex flex-col gap-1.5 sm:gap-2 lg:gap-[0.69rem]">
                  {link.links.map((link) => (
                    <li key={link.label}>
                      {link.target ? (
                        <a
                          href={link.to}
                          target={link.target || '_blank'}
                          rel="noopener noreferrer"
                          className="inline-block text-[#888888] hover:text-white hover:underline transition-colors text-[0.825rem] sm:text-sm md:text-[0.925rem] lg:text-base font-normal leading-4 sm:leading-5 md:leading-6 sm:whitespace-nowrap"
                        >
                          {link.label}
                        </a>
                      ) : (
                        <Link 
                          to={link.to}
                          className="inline-block text-[#888888] hover:text-white hover:underline transition-colors text-[0.825rem] sm:text-sm md:text-[0.925rem] lg:text-base font-normal leading-4 sm:leading-5 md:leading-6 sm:whitespace-nowrap"
                        >
                          {link.label}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </nav>
          ))}
        </div>
        <div className="flex flex-col items-center max-w-[96.375rem] mx-auto">
          <div className="space-y-5 w-full text-center sm:space-y-6 md:space-y-7 lg:space-y-8 py-3.5 sm:py-4 lg:py-[1.125rem]">
            <div className="w-24 sm:w-[6.1875rem] h-10 sm:h-[2.93769rem] mx-auto">
              <img
                src="/assets/vle-logo-white.svg"
                className="object-contain w-full h-full"
                alt="VLE Mobile Logo"
              />
            </div>
            <nav aria-label="Footer Navigation">
              <ul className="w-[90%] sm:w-full flex flex-wrap justify-center gap-x-6 gap-y-2 sm:gap-x-10 sm:gap-y-2.5 md:gap-x-14 md:gap-y-3 mx-auto">
                {bottomFooterLinks.map((link) => (
                  <li key={link.label}>
                    {link.target ? (
                      <a
                        href={link.to}
                        target={link.target || '_blank'}
                        rel="noopener noreferrer"
                        className="inline-flex items-center text-[#888888] hover:text-white hover:underline transition-colors text-xs sm:text-[0.8125rem] md:text-sm font-medium leading-4 sm:leading-5 md:leading-6"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link 
                        to={link.to}
                        className="inline-flex items-center text-[#888888] hover:text-white hover:underline transition-colors text-xs sm:text-[0.8125rem] md:text-sm font-medium leading-4 sm:leading-5 md:leading-6"
                      >
                        {link.label === 'Your Privacy Choices' && (
                          <img src="/assets/privacy-choices-icon.svg" alt="Privacy Choices" className="w-[1.625rem] sm:w-7 lg:w-[1.875rem] h-2.5 sm:h-3 lg:h-3.5 mr-1 sm:mr-1.5 lg:mr-2" />
                        )}
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
          </div>
          <div className="w-full flex flex-col md:flex-row justify-between items-center gap-3 sm:gap-4 md:gap-5 lg:gap-6 pt-6 sm:pt-7 md:pt-8 lg:pt-[2.525rem] border-t border-[#64728D33]">
            <nav aria-label="Social Media Links">
              <ul className="flex gap-3 items-center sm:gap-4">
                {socialLinks.map((social) => (
                  <li key={social.alt}>
                    <a 
                      href={social.to}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block w-5 h-5 transition-all sm:w-6 sm:h-6 hover:opacity-85 hover:scale-105"
                      aria-label={social.alt}
                    >
                      <img 
                        src={social.icon} 
                        className="w-full h-full" 
                        aria-hidden="true"
                        alt={social.alt} 
                      />
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
            <p className="text-center text-white/50 text-[0.72rem] sm:text-[0.785rem] md:text-[0.8125rem] font-normal leading-4 md:leading-[1.05rem]">
              All Rights Reserved © 2025. VLE Mobile® a C & G Discounts CO Brand
            </p>
          </div>
        </div>
      </footer>
    </React.Fragment>
  );
}
